Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        mail_address: '',
        primary: false,
        protected: false
    },

    validation: {
        mail_address: [
            {
                required: false,
                pattern: 'email',
                msg: 'input.user.mail_address.validation.invalid'
            }
        ]
    },

    getAddress: function() {
        return this.get('mail_address');
    },

    isPrimary: function() {
        return this.get('primary');
    },

    isProtected: function() {
        return this.get('protected');
    },

    init: function() {
        _.bindAll(this, '_changePrimary');
        this.listenTo(this, 'changePrimary', this._changePrimary);
    },

    _changePrimary: function() {
        var self = this;
        console.log('call _changePrimary', self);
        if (this.collection) {
            this.collection.each(function(m) {
                if (m.cid != self.cid) {
                    m.set('primary', false);
                }
            });
            if (!this.get('primary')) {
                this.collection.at(0).set('primary', true);
            }
        }
    },

    isLeviiDomain: function () {
        return this.getAddress().split('@', 2)[1] === 'levii.co.jp'
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/user-email.js